// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  baseApiUrl: 'https://presales.nfpc.net/production/public/api',
  nfpcApiUrl: 'https://presales.nfpc.net/production/public/api',
  sapUrl: 'https://presales.nfpc.net/production',
  host: 'https://presales.nfpc.net',
  // baseApiUrl: 'https://presales-dev.nfpc.net/production/public/api',
  // sapUrl: 'https://presales-dev.nfpc.net/production',
  // nfpcApiUrl: 'https://presales-dev.nfpc.net/production/public/api',
  // host: 'https://presales-dev.nfpc.net',
  //   production: false

  production: false
};

//dev url https://devmobiato.nfpc.net//merchandising/public/api
//prod url https://devmobiato.nfpc.net/production/public/api

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
